import { render, staticRenderFns } from "./ImpactSelect.vue?vue&type=template&id=2cd7b7d9&"
import script from "./ImpactSelect.vue?vue&type=script&lang=js&"
export * from "./ImpactSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports